import Env from "../base/env";

export function getViewport() {
  return {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    outerWidth: window.innerWidth,
    outerHeight: window.innerHeight,
  };
}

export function getCoords(el) {
  return el.getBoundingClientRect();
}

export function scrollPosition() {
  /*https://developer.mozilla.org/fr/docs/Web/API/document/scrollingElement*/
  let getScrollY;
  const getViewport = {
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    outerWidth: window.innerWidth,
    outerHeight: window.innerHeight,
  };
  const pageHeight = Math.round(
    Env.$master.getBoundingClientRect().height - getViewport.height
  );
  if (document.scrollingElement && document.scrollingElement.scrollTop) {
    getScrollY = document.scrollingElement.scrollTop;
  } else if (document.documentElement && document.documentElement.scrollTop) {
    getScrollY = document.documentElement.scrollTop;
  } else {
    getScrollY = Env.$body.scrollTop;
  }
  // const getScrollY = (document.documentElement && document.documentElement.scrollTop) || Env.$body.scrollTop
  return { scrollY: getScrollY, fullPageHeight: pageHeight };
}

export function getCssData(el, attr) {
  return window.getComputedStyle(el)[attr];
}

// Map number x from range [a, b] to [c, d]
export function map(x, a, b, c, d) {
  ((x - a) * (d - c)) / (b - a) + c;
}

// Linear interpolation
export function lerp(a, b, n) {
  (1 - n) * a + n * b;
}

export function calcWinsize() {
  return { width: window.innerWidth, height: window.innerHeight };
}

// Gets the mouse position
export function getMousePos(e) {
  return {
    x: e.clientX,
    y: e.clientY,
  };
}

export function distance(x1, y1, x2, y2) {
  var a = x1 - x2;
  var b = y1 - y2;

  return Math.hypot(a, b);
}

// Generate a random float.
export function getRandomFloat(min, max) {
  (Math.random() * (max - min) + min).toFixed(2);
}

export function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
}
